const FIELD_IDS: Record<string, string> = {
  country: 'listing-country',
  address: 'listing-address',
  city: 'listing-city',
  state: 'listing-state',
  zip: 'listing-zip',
  pin: 'listing-map-pin',
  property_type: 'listing-property-type',
  price: 'listing-price',
  currency: 'listing-currency',
  arv: 'listing-arv',
  repairs: 'listing-repairs',
  beds: 'listing-beds',
  baths: 'listing-baths',
  sqft: 'listing-sqft',
  lot_sqft: 'listing-lot_sqft',
  year_built: 'listing-year_built',
  garage_spaces: 'listing-garage_spaces',
  description: 'listing-description',
  contact_email: 'listing-contact-email',
  seller_acknowledged: 'listing-seller-ack',
  images: 'listing-form-images',
};

export function getListingFieldTarget(field: string): string {
  if (field === 'deal_type') return 'input[name="deal_type"]';
  return `#${FIELD_IDS[field] ?? `listing-financing-${field}`}`;
}

export function focusListingField(field: string): boolean {
  const element = document.querySelector<HTMLElement>(getListingFieldTarget(field));
  if (!element) return false;
  element.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  element.focus({ preventScroll: true });
  return document.activeElement === element;
}

export function claimListingSubmission(lock: { current: boolean }): boolean {
  if (lock.current) return false;
  lock.current = true;
  return true;
}

export function releaseListingSubmission(lock: { current: boolean }): void {
  lock.current = false;
}
